/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import icon from 'flarum/common/helpers/icon';
import type Mithril from 'mithril';
import type Bookshelf from '../../common/models/Bookshelf';

export interface BookshelfPrivacyLabelAttrs extends ComponentAttrs {
	bookshelf: Bookshelf;
}

export default class BookshelfPrivacyLabel<
	CustomAttrs extends BookshelfPrivacyLabelAttrs = BookshelfPrivacyLabelAttrs,
> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { bookshelf } = this.attrs;

		return (
			<div className="BookshelfPrivacyLabel">
				{bookshelf.isPrivate()
					? [icon('far fa-lock-alt'), app.translator.trans('glowingblue-orell-bookshelf.forum.bookshelves.status_private')]
					: [icon('far fa-globe-europe'), app.translator.trans('glowingblue-orell-bookshelf.forum.bookshelves.status_public')]}
			</div>
		);
	}
}
